import React, { forwardRef, useImperativeHandle, useState } from "react";
import {
  Form,
  Input,
  Modal,
  notification,
  Select,
  Spin,
  DatePicker,
} from "antd";
import { editDishonestPersonnel } from "../../../common/request";
import ResponseCode from "../../../common/response-code";
import { errorModal } from "../../../plugins/utils";
import dayjs from "dayjs";

/** 机构管理-机构配置-不诚信人员-弹窗 */
const DishonestPersonnelModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [show, setShow] = useState(false);
  const [personnelId, setPersonnelId] = useState(false);
  const [type, setType] = useState(false);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);

  const violationTypeList = [
    { value: "作弊" },
    { value: "替考" },
    { value: "扰乱考场秩序" },
    { value: "携带违禁物品" },
    { value: "其他违纪行为" },
  ];

  useImperativeHandle(ref, () => {
    return { showModal };
  });

  /** 打开弹窗 */
  const showModal = (modalType, data) => {
    const titleMappings = { insert: "人员信息录入", update: "人员信息编辑" };
    setTitle(titleMappings[modalType]);
    setType(modalType);
    if (modalType === "update") {
      const { id, examBanStartTime, examBanEndTime } = data;
      setPersonnelId(id);
      data.examBanStartTime = dayjs(examBanStartTime, "YYYY-MM-DD HH:mm:ss");
      data.examBanEndTime = dayjs(examBanEndTime, "YYYY-MM-DD HH:mm:ss");
      form.setFieldsValue(data);
    }
    setShow(true);
  };

  /** 关闭弹窗 */
  const closeModal = () => {
    setShow(false);
    form.resetFields();
  };

  /** 提交信息 */
  const submit = async () => {
    try {
      const formData = await form.validateFields();
      operate(formData);
    } catch (error) {}
  };

  /** 新增/更新不诚信人员 */
  const operate = async (formData) => {
    setLoading(true);
    try {
      const {
        examBanStartTime: startTime,
        examBanEndTime: endTime,
        ...rest
      } = formData;
      const examBanStartTime = startTime.format("YYYY-MM-DD HH:mm:ss");
      const examBanEndTime = endTime.format("YYYY-MM-DD HH:mm:ss");
      const params = {
        orgId: props.orgId,
        ...rest,
        examBanStartTime,
        examBanEndTime,
      };
      if (type === "update") params.id = personnelId;
      const res = await editDishonestPersonnel(params, type);
      setLoading(false);
      if (res.code !== ResponseCode.success) return errorModal(res.msg);
      notification.success({ message: "操作成功" });
      closeModal();
      props.success?.();
    } catch (error) {
      setLoading(false);
      console.error(error);
      errorModal("网络错误，操作失败");
    }
  };

  return (
    <Modal
      open={show}
      title={title}
      onCancel={closeModal}
      onOk={submit}
      confirmLoading={loading}
    >
      <Spin spinning={loading}>
        <Form
          className={"my-4"}
          form={form}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 14 }}
        >
          <Form.Item label="姓名" name="name" rules={[{ required: true }]}>
            <Input placeholder="请输入姓名" />
          </Form.Item>
          <Form.Item
            label="身份证号"
            name="idCard"
            rules={[{ required: true }]}
          >
            <Input placeholder="请输入18位身份证号" />
          </Form.Item>
          <Form.Item
            label="考试名称"
            name="examName"
            rules={[{ required: true }]}
          >
            <Input placeholder="请输入考试名称" />
          </Form.Item>
          <Form.Item
            label="违纪类型"
            name="violationType"
            trigger="onChange"
            rules={[{ required: true, message: "请选择违纪类型" }]}
          >
            <Select options={violationTypeList} placeholder="请选择违纪类型" />
          </Form.Item>
          <Form.Item
            label="禁考起始日期"
            name="examBanStartTime"
            rules={[{ required: true, message: "请选择禁考起始日期" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              placeholder="请选择禁考起始日期"
              showTime
            />
          </Form.Item>
          <Form.Item
            label="禁考截止日期"
            name="examBanEndTime"
            rules={[
              { required: true, message: "请选择禁考截止日期" },
              {
                validator: async (_, value) => {
                  const startTime = form.getFieldValue("examBanStartTime");
                  if (startTime >= value) {
                    return Promise.reject(
                      new Error("截止日期不可早于起始日期")
                    );
                  }
                },
              },
            ]}
          >
            <DatePicker
              style={{ width: "100%" }}
              placeholder={"请选择禁考截止日期"}
              showTime
            />
          </Form.Item>
          <Form.Item label="违纪详情" name="violationDetail">
            <Input.TextArea
              style={{ height: 80, resize: "none" }}
              placeholder="请输入违纪详情"
            />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
});

export default DishonestPersonnelModal;
